import { render } from "./FormFloatingLabelsPage.vue?vue&type=template&id=648742af&ts=true"
import script from "./FormFloatingLabelsPage.vue?vue&type=script&lang=ts"
export * from "./FormFloatingLabelsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__